import { render } from "./HomePromessa.vue?vue&type=template&id=db0afe9c"
import script from "./HomePromessa.vue?vue&type=script&lang=js"
export * from "./HomePromessa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__